export default {
    easy: 'FACILÍSIMO',
    medium: 'UN POCO DURA',
    hard_1: 'Bien',
    hard_2: 'difícil',
    hard_3: '',
};
